import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs';
import { Contest } from 'src/app/models/contest';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ButtonsModalComponent } from '../buttons-modal/buttons-modal.component';
import { ConfirmTermsAndConditionComponent } from '../confirm-terms-and-condition/confirm-terms-and-condition.component';

@Component({
  selector: 'app-select-contest',
  templateUrl: './select-contest.component.html',
  styleUrls: ['./select-contest.component.scss'],
})
export class SelectContestComponent implements OnInit {
  @Input() contests: Array<Contest> = [];
  @Input() role!: number;
  @Output() onSelectContest: EventEmitter<Contest> =
    new EventEmitter<Contest>();

  @Output() nextPage: EventEmitter<string> = new EventEmitter<string>();
  loading!: boolean;
  start = false;
  buttonsList: any;
  isPqrsActive: any = false;

  constructor(
    private modalCtrl: ModalController,
    private authService: AuthService,
    private toolService: ToolsService,
    private router: Router,
    private route: ActivatedRoute,
    private configSvc: ConfigService
  ) {}

  ngOnInit() {
    if (this.role) {
      this.authService
        .getRoleById(this.role)
        .pipe(finalize(() => (this.loading = false)))
        .subscribe({
          next: (response) => {
            if (response) {
              this.openModal(this.role, response);
            }
          },
          error: (error) => {
            console.error('Error obteniendo :', error);
            this.toolService.presentErrorToast('Error al obtener el rol');
          },
        });
    } else {
      this.getButtons();
    }

    this.isPqrsActive = this.configSvc.mall?.pqrs_active

  }

  selectContest(contest: Contest) {
    this.onSelectContest.emit(contest);
  }


  async openModal(role: number, data: any) {
    const modal = await this.modalCtrl.create({
      component: ConfirmTermsAndConditionComponent,
      componentProps: {
        role,
        data,
      },
      cssClass: 'custom-modal-dialog',
    });

    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.nextPage.emit('login');
        this.router.navigate(['/'], {
          queryParams: { role: this.role, start: true },
        });
      }
    });
    await modal.present();
  }

  async getButtons() {
    this.loading = true;
    this.authService
      .getButtonsRoles()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (response) => {
          if (response.length > 0) {
            this.buttonsList = response;
            //this.openModalButtons(response);
          }
        },
        error: (error) => {
          console.error('Error obteniendo los botones:', error);
        },
      });
  }

  async openModalButtons(buttons: any) {
    if (buttons.length > 1) {
      const modal = await this.modalCtrl.create({
        component: ButtonsModalComponent,
        cssClass: 'custom-modal',
        componentProps: {
          buttons,
        },
      });

      modal.onDidDismiss().then((data) => {
        if (data.data) {
          this.nextPage.emit('login');
          this.router.navigate(['/'], {
            queryParams: { start: true },
          });
        }
      });
      await modal.present();
    } else {
      this.openModal(buttons[0].id, buttons[0]);
    }
  }

  goToPqrs(){
    this.router.navigate(['client-pqr'])
  }
}
